import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from 'react-confirm-alert';         //알럿창(alert confirm)

import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageResize from 'quill-image-resize';

Quill.register('modules/ImageResize', ImageResize);

class CustomerEdit extends Component {
  state = {
    idx: 0,
    category: 0,
    board_id: 0,
    title: '',
    content: '',
    notice: 0,
  };
  _isMounted = false;

  modules = {
    toolbar: {
      container: '#toolbar',
      /*
            container: [
                //[{ 'font': [] }],
                [{ 'header': [1, 2, false] }],
                ['bold', 'italic', 'underline','strike', 'blockquote'],
                [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                ['link', 'image'],
                [{ 'align': [] }, { 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                ['clean']
            ],
            */
      handlers: {
        image: () => this._imageHandler(),
        undo: () => this.undoChange(),
        redo: () => this.redoChange(),
      },
    },

    ImageResize: {
      parchment: Quill.import('parchment'),
    },
  };

  formats = [
    //'font',
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'align',
    'color',
    'background',
  ];

  componentDidMount = () => {
    this._isMounted = true;
    const { idx, title, content, categoryID, board_id, chkNotice } =
      this.props.childProps;

    if (this._isMounted) {
      this.setState({
        idx: idx,
        category: categoryID,
        board_id: board_id,
        title: title,
        content: content,
        notice: chkNotice,
      });
    }
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _imageHandler = () => {
    //console.log('img handler...')
    const input = document.createElement('input');
    // 속성 써주기
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.addEventListener('change', async () => {
      //console.log('온체인지');
      const file = input.files[0];
      // multer에 맞는 형식으로 데이터 만들어준다.
      const formData = new FormData();
      formData.append('upload', file); // formData는 키-밸류 구조
      // 백엔드 multer라우터에 이미지를 보낸다.
      try {
        const result = await axios.post(
          'https://ticket.aniplustv.com:3100/uploadBoard',
          formData
        );
        //console.log(result)
        //console.log('성공 시, 백엔드가 보내주는 데이터', result.data.url);

        const IMG_URL = result.data.url;
        // 이 URL을 img 태그의 src에 넣은 요소를 현재 에디터의 커서에 넣어주면 에디터 내에서 이미지가 나타난다
        // src가 base64가 아닌 짧은 URL이기 때문에 데이터베이스에 에디터의 전체 글 내용을 저장할 수있게된다
        // 이미지는 꼭 로컬 백엔드 uploads 폴더가 아닌 다른 곳에 저장해 URL로 사용하면된다.
        //console.log(this.quillRef)
        // 이미지 태그를 에디터에 써주기 - 여러 방법이 있다.
        const editor = this.quillRef.getEditor(); // 에디터 객체 가져오기
        // 1. 에디터 root의 innerHTML을 수정해주기
        // editor의 root는 에디터 컨텐츠들이 담겨있다. 거기에 img태그를 추가해준다.
        // 이미지를 업로드하면 -> 멀터에서 이미지 경로 URL을 받아와 -> 이미지 요소로 만들어 에디터 안에 넣어준다.
        // editor.root.innerHTML =
        //   editor.root.innerHTML + `<img src=${IMG_URL} /><br/>`; // 현재 있는 내용들 뒤에 써줘야한다.

        // 2. 현재 에디터 커서 위치값을 가져온다
        const range = editor.getSelection();
        // 가져온 위치에 이미지를 삽입한다
        setTimeout(() => {
          editor.insertEmbed(range.index, 'image', IMG_URL);
        }, 500);
      } catch (error) {
        //console.log(error)
        alert('이미지를 업로드중 오류가 발생했습니다. 다시 시도해 주세요');
      }
    });
  };

  _onChange = (e) => {
    //console.log(e.target.value)
    this.setState({
      category: e.target.value,
    });
  };
  _textChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  _onContentChange = (value) => {
    //console.log(value)
    if (this._isMounted) {
      this.setState({
        content: value,
      });
    }
  };
  handleClickShowRaw = () => {
    const { showRaw } = this.state;
    if (this._isLoad) {
      this.setState({
        showRaw: !showRaw,
      });
      this.syncViews(showRaw);
    }
  };
  insertVideo = () => {
    const { content } = this.state;
    //alert(0)
    //ReactQuill.insertEmbed(10, 'image', 'https://quilljs.com/images/cloud.png');
    //var range = this.quillRef.getEditor().getSelection();
    //let position = range ? range.index : 0;
    //this.quillRef.insertText(position, 'Hello, World! ')
    //console.log(range)
    //console.log(position)
    //console.log(this.quillRef.getEditor())
    //this.quillRef.getEditor().insertText(position, '<div>test!!!</div>')
    //this.quillRef.getEditor().insertEmbed(0, 'video', 'https://www.youtube.com/embed/QHH3iSeDBLo');

    var htmlToInsert =
      '<p><iframe class="embed-responsive-item" src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0" frameborder="0"></iframe></p>';
    //var htmlToInsert = "<p><video width='350'><source src='https://www.youtube.com/embed/zpOULjyy-n8?rel=0' /></video></p>"
    var editor = document.getElementsByClassName('ql-editor');
    editor[0].innerHTML = content + htmlToInsert;

    // this.quillRef.getEditor().insertEmbed(position, 'audio', 'https://www.sample-videos.com/audio/mp3/crowd-cheering.mp3', 'user');
  };
  /*
    _onContentChange = (e) => {
      
        this.setState({
            content: e
        })
    }
    */

  _onSubmit = async () => {
    const { loginId, pkg } = this.props;
    const { title, content, category } = this.state;
    const { getData, closeEdit } = this.props.childProps;
    if (
      loginId === '' ||
      loginId === null ||
      loginId === undefined ||
      pkg === '' ||
      pkg === null ||
      pkg === undefined
    ) {
      toast.warn('로그인후 이용해 주세요.');
      return;
    }
    if (title === '' || title === null || title === undefined) {
      toast.warn('제목을 입력해 주세요.');
      return;
    }
    if (content === '' || content === null || content === undefined) {
      toast.warn('내용을 입력해 주세요');
      return;
    }
    if (
      category === '' ||
      category === null ||
      category === undefined ||
      category === 0
    ) {
      toast.warn('분류를 선택해 주세요');
      return;
    }

    const result = await this._onSubmitApi();
    if (result) {
      const intReturn = result.data[0].intReturn;

      if (intReturn === 0) {
        if (this._isMounted) {
          toast.success('글이 성공적으로 수정 되었습니다.');
          this.setState({
            title: '',
            content: '',
            category: 0,
          });
          //toggleWrite()
          //writeOk(board_id, 1, 0)
          closeEdit();
          setTimeout(() => {
            getData();
          }, 500);
        }
        //this._getBoardData(board_id, 1, category)
      }
    }

    ////console.log(title)
    ////console.log(content)
  };

  _onSubmitApi = () => {
    const { apiUrl, loginId, authId, pkg, history } = this.props;
    const { idx, title, content, board_id, category, notice } = this.state;
    // const at = localStorage.getItem("at");
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/boardEdit_pkg',
        {
          params: {
            userid: loginId,
            authId: authId,
            idx: idx,
            board_id: board_id,
            title: title,
            category: category,
            content: content,
            notice: notice,
            pkg: pkg,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._onSubmit();
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };

  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _showWrite = () => {
    const { closeEdit } = this.props.childProps;
    closeEdit();

    /*
        const { write } = this.state;
        this.setState({
            write: !write
        })
        */
  };
  _onSelectFile = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        file: file,
        fileName: file.name,
      });
    };
    reader.readAsDataURL(file);

    //이미지 업로드 처리.
    this._imgUpload(file);
  };
  _imgUpload = async (file) => {
    const { loginId, aspUrl } = this.props;
    const formData = new FormData();
    formData.append('img', file);
    formData.append('userid', loginId);
    // 서버의 upload API 호출
    //alert(0)
    const result = await axios.post(aspUrl + '/boardImgUpload.asp', formData);
    const intReturn = result.data[0].intReturn;
    const imgName = result.data[0].imgName;
    if (intReturn === 0) {
      this.setState({
        imgName,
      });
    }
    ////console.log(res)
  };
  _onNotice = () => {
    const { notice } = this.state;
    this.setState({
      notice: notice === 0 ? 1 : 0,
    });
  };
  render() {
    const { board_id, category, title, content, notice } = this.state;
    const { loginId } = this.props;
    return (
      <Fragment>
        <div className="service_content">
          {/*
                    <h2>
                        <a style={{cursor: 'pointer', right: 80, position: 'absolute'}} className='on' onClick={this._showWrite} >글 목록</a>
                    </h2>
                    */}
          <table
            width="100%"
            border="0"
            cellSpacing="0"
            cellPadding="0"
            className="customer_table3"
          >
            <tbody>
              <tr>
                {board_id === 20 ? (
                  <th colSpan="2">
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_1"
                        type="checkbox"
                        value="202"
                        checked={category === '202' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_1">쇼핑</label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_2"
                        type="checkbox"
                        value="203"
                        checked={category === '203' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_2">로그인 </label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_3"
                        type="checkbox"
                        value="204"
                        checked={category === '204' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_3">플레이어 </label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_4"
                        type="checkbox"
                        value="205"
                        checked={category === '205' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_4">해지</label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_5"
                        type="checkbox"
                        value="206"
                        checked={category === '206' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_5">상영회</label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_6"
                        type="checkbox"
                        value="207"
                        checked={category === '207' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_6">멤버십</label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_7"
                        type="checkbox"
                        value="208"
                        checked={category === '208' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_7">포인트</label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_8"
                        type="checkbox"
                        value="209"
                        checked={category === '209' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_8">콘텐츠</label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_9"
                        type="checkbox"
                        value="210"
                        checked={category === '210' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_9">서비스</label>
                    </div>
                  </th>
                ) : (
                  <th colSpan="2">
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_1"
                        type="checkbox"
                        value="1"
                        checked={category === '1' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_1">VOD</label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_2"
                        type="checkbox"
                        value="2"
                        checked={category === '2' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_2">멤버십 </label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_3"
                        type="checkbox"
                        value="3"
                        checked={category === '3' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_3">환불 </label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_4"
                        type="checkbox"
                        value="4"
                        checked={category === '4' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_4">상품</label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_5"
                        type="checkbox"
                        value="5"
                        checked={category === '5' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_5">배송</label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_6"
                        type="checkbox"
                        value="9"
                        checked={category === '9' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_6">자막오류</label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_7"
                        type="checkbox"
                        value="10"
                        checked={category === '10' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_7">저작권 침해 신고</label>
                    </div>
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_8"
                        type="checkbox"
                        value="12"
                        checked={category === '12' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_8">이벤트</label>
                    </div>
                    {/*
                                    <div className="chek_group">
                                        <input name="선택" id="checkbox_9" type="checkbox" value="101" checked={category === '101' ? true : false} className="checkbox_img" onChange={this._onChange}/><label htmlFor="checkbox_9">쇼핑</label>
                                    </div>
                                    */}
                    <div className="chek_group">
                      <input
                        name="선택"
                        id="checkbox_10"
                        type="checkbox"
                        value="11"
                        checked={category === '11' ? true : false}
                        className="checkbox_img"
                        onChange={this._onChange}
                      />
                      <label htmlFor="checkbox_10">기타</label>
                    </div>
                  </th>
                )}
              </tr>
              <tr>
                <td>제목</td>
                <td>
                  <input
                    name="title"
                    type="text"
                    value={title}
                    className="common_input customer_input"
                    placeholder="제목을 입력해 주세요."
                    onChange={this._textChange}
                  />
                </td>
              </tr>

              <tr>
                <td>내용</td>
                <td style={{ height: 280, verticalAlign: 'top' }}>
                  <CustomToolbar
                    onClickRaw={this.handleClickShowRaw}
                    onInsertVideo={this.insertVideo}
                  />
                  <ReactQuill
                    ref={(el) => (this.quillRef = el)}
                    style={{ height: 400, display: 'block' }}
                    theme="snow"
                    modules={this.modules}
                    formats={this.formats}
                    placeholder={'내용을 입력해주세요'}
                    value={content || ''}
                    onChange={(content, delta, source, editor) =>
                      this._onContentChange(editor.getHTML())
                    }
                  />
                </td>
              </tr>
              {loginId === 'admin' && board_id === 4 ? (
                <tr>
                  <td>공지글</td>
                  <td>
                    <input
                      type="checkbox"
                      value={notice}
                      checked={notice === 0 ? false : true}
                      onChange={this._onNotice}
                    />
                  </td>
                </tr>
              ) : null}

              {/*
                        <tr>
                            <td>파일첨부</td>
                            <td>
                                <div className="update_file ">
                                    <ul>
                                        <li><input type="text" value={fileName || ''} readOnly className="common_input file_input"/></li>
                                        <li className="btn_upload" id="">
                                            <input type="file" accept='image/jpg,impge/png,image/jpeg,image/gif' className="file_opacity" onChange={this._onSelectFile} />
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        */}
            </tbody>
          </table>
          <div>
            <span>
              <input
                type="button"
                value="글 수정"
                className="customer_button common_input"
                onClick={this._onSubmit}
              />
            </span>
            <span>
              <input
                type="button"
                value="취소"
                className="customer_button common_input"
                onClick={this._showWrite}
              />
            </span>
          </div>
        </div>
      </Fragment>
    );
  }
}
const CustomToolbar = ({ onClickRaw, onInsertVideo }) => (
  <div id="toolbar">
    <span className="ql-formats">
      {/*
        <select className="ql-font" defaultValue="arial">
          <option value="arial">Arial</option>
          <option value="comic-sans">Comic Sans</option>
          <option value="courier-new">Courier New</option>
          <option value="georgia">Georgia</option>
          <option value="helvetica">Helvetica</option>
          <option value="lucida">Lucida</option>
          <option value="돋움">돋움</option>
          <option value="굴림">굴림</option>
        </select>
        
        <select className="ql-size" defaultValue="medium">
          <option value="extra-small">Size 1</option>
          <option value="small">Size 2</option>
          <option value="medium">Size 3</option>
          <option value="large">Size 4</option>
        </select>
        */}
      <select className="ql-header" defaultValue="3">
        <option value="1">Heading</option>
        <option value="2">Subheading</option>
        <option value="3">Normal</option>
      </select>
    </span>
    <span className="ql-formats">
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
      <button className="ql-strike" />
    </span>
    <span className="ql-formats">
      <button className="ql-list" value="ordered" />
      <button className="ql-list" value="bullet" />
      <button className="ql-indent" value="-1" />
      <button className="ql-indent" value="+1" />
    </span>
    <span className="ql-formats">
      <button className="ql-script" value="super" />
      <button className="ql-script" value="sub" />
      <button className="ql-blockquote" />
      <button className="ql-direction" />
    </span>
    <span className="ql-formats">
      <select className="ql-align" />
      <select className="ql-color" />
      <select className="ql-background" />
    </span>
    <span className="ql-formats">
      <button className="ql-link" />
      <button className="ql-image" />
      {/*<button className="ql-video" />*/}
    </span>
    <span className="ql-formats">
      <button className="ql-formula" />
      <button className="ql-code-block" />
      <button className="ql-clean" />
    </span>
    <span className="ql-formats">
      <button
        style={{ fontSize: 7, fontWeight: 900, width: 50 }}
        onClick={onClickRaw}
      >
        {'</>'}
      </button>
    </span>
    {/*
      <span className="ql-formats">
        <button style={{ fontSize: 7, fontWeight: 900, width: 50 }} onClick={onInsertVideo}>{'</>'}</button>
      </span>
      */}
    {/*
      <span className="ql-formats">
        <button className="ql-undo">
          <CustomUndo />
        </button>
        <button className="ql-redo">
          <CustomRedo />
        </button>
      </span>
      */}
  </div>
);
/*
  const CustomUndo = () => (
    <svg viewBox="0 0 18 18">
      <polygon className="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10" />
      <path
        className="ql-stroke"
        d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
      />
    </svg>
  );
  
  // Redo button icon component for Quill editor
  const CustomRedo = () => (
    <svg viewBox="0 0 18 18">
      <polygon className="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10" />
      <path
        className="ql-stroke"
        d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
      />
    </svg>
  );
  */
export default shopContext(withRouter(CustomerEdit));
